import React from 'react';

const Tether = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 113.45 31.75">
      <g id="tether">
        <path
          d="M.5,31.25a157.08,157.08,0,0,0,14.15-6.9q14.3-7.76,14.75-12v-.05Q23.21,8.41,22.75,5.7a3.36,3.36,0,0,1,1.9-3.9Q27,.6,29,4.1t.45,8.2q4.8,1.5,32-3.15T96.25,5.4l8.15.45A13.24,13.24,0,0,0,113,.5"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default Tether;
